export const LADE_AUSWAHLWERTE_VERANSTALTUNG = "ladeAuswahlwerteVeranstaltung";
export const LADE_KURSVORLAGEN = "ladeKursvorlagen";
export const LADE_AUSWAHLWERTE_ANMLEDEFORMULAR =
  "ladeAuswahlwerteAnmeldeformular";
